var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClasses(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Classes",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M5.29736308,15.6025846 L4.07863385,18.0261231 C4.01689846,18.1489846 4.10615077,18.2937231 4.24356923,18.2937231 L6.66712615,18.2937231 C6.80417538,18.2937231 6.89344615,18.1496308 6.83244,18.0269538 L5.62761231,15.6034154 C5.55989538,15.4671692 5.36571692,15.4667077 5.29736308,15.6025846 Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 5.455,
    cy: 14.518,
    r: 1.51,
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M11.8486154,7.04314154 L9.61712308,11.4806769 C9.55538769,11.6034462 9.64464,11.7482769 9.78205846,11.7482769 L14.2196308,11.7482769 C14.3566154,11.7482769 14.4459692,11.6041846 14.3849538,11.4814154 L12.1788923,7.04389846 C12.1111385,6.90767077 11.9170154,6.90722769 11.8486154,7.04314154 Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 12,
    cy: 5.455,
    r: 2.517,
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M11.8428923,18.2879077 L10.6241538,20.7114462 C10.5624,20.8342154 10.6516615,20.9790462 10.7891077,20.9790462 L13.2126462,20.9790462 C13.3497231,20.9790462 13.4389846,20.8349538 13.3779692,20.7121846 L12.1731692,18.2886462 C12.1054154,18.1524 11.9112,18.1520308 11.8428923,18.2879077 Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 12,
    cy: 17.203,
    r: 1.51,
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M18.3882462,15.6025846 L17.1695077,18.0261231 C17.1078462,18.1489846 17.1971077,18.2937231 17.3344615,18.2937231 L19.758,18.2937231 C19.8950769,18.2937231 19.9843385,18.1496308 19.9233231,18.0269538 L18.7185231,15.6034154 C18.6507692,15.4671692 18.4566462,15.4667077 18.3882462,15.6025846 Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 18.546,
    cy: 14.518,
    r: 1.51,
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 12,
    cy: 12,
    r: 11.5,
    stroke: "currentColor"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClasses);
export default __webpack_public_path__ + "static/media/Classes.51894532.svg";
export { ForwardRef as ReactComponent };